<template>
  <div class="page-container">
    <el-card v-loading="loading">
      <div slot="header" class="page-header">
        <span class="page-title">优惠券详情</span>
        <div class="page-actions">
          <el-button size="small" icon="el-icon-arrow-left" @click="$router.push('/coupon/index')">返回</el-button>
          <el-button
            v-permission="['coupon:issue']"
            type="success" size="small" icon="el-icon-s-promotion"
            @click="$router.push(`/coupon/issue?id=${couponId}`)"
          >发放</el-button>
          <el-button
            v-permission="['coupon:update']"
            type="primary" size="small" icon="el-icon-edit"
            @click="$router.push(`/coupon/edit?id=${couponId}`)"
          >编辑</el-button>
        </div>
      </div>

      <template v-if="coupon">
        <el-form label-width="120px" class="detail-form" size="small">

          <el-form-item label="优惠券名称">
            <span class="val-text bold">{{ coupon.name }}</span>
          </el-form-item>

          <el-form-item label="立减金额">
            <span class="val-price">¥{{ Number(coupon.amount).toFixed(2) }}</span>
          </el-form-item>

          <el-form-item label="可用产品">
            <span v-if="coupon.product" class="val-text">{{ coupon.product.name }}</span>
            <span v-else class="text-muted">不限产品（通用券）</span>
          </el-form-item>

          <el-form-item label="有效期">
            <span class="val-text">{{ coupon.started_at }} 至 {{ coupon.expired_at }}</span>
          </el-form-item>

          <el-form-item label="状态">
            <el-tag :type="coupon.status === 1 ? 'success' : 'info'" size="small">
              {{ coupon.status === 1 ? '启用' : '禁用' }}
            </el-tag>
          </el-form-item>

          <el-form-item label="创建时间">
            <span class="val-text">{{ coupon.created_at }}</span>
          </el-form-item>

          <el-form-item label="最后更新">
            <span class="val-text">{{ coupon.updated_at }}</span>
          </el-form-item>

          <el-form-item>
            <el-button size="small" @click="$router.push('/coupon/index')">返回列表</el-button>
            <el-button
              v-permission="['coupon:issue']"
              type="success" size="small" icon="el-icon-s-promotion"
              @click="$router.push(`/coupon/issue?id=${couponId}`)"
            >发放此优惠券</el-button>
            <el-button
              v-permission="['coupon:update']"
              type="primary" size="small" icon="el-icon-edit"
              @click="$router.push(`/coupon/edit?id=${couponId}`)"
            >编辑</el-button>
          </el-form-item>

        </el-form>
      </template>
    </el-card>
  </div>
</template>

<script>
import { getCouponDetail } from '@/api/coupon'

export default {
  name: 'CouponDetail',
  data() {
    return {
      loading: false,
      coupon: null
    }
  },
  computed: {
    couponId() {
      return this.$route.query.id ? Number(this.$route.query.id) : null
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        if (to.path !== '/coupon/detail') return
        if (to.query.id) {
          this.fetchDetail()
        } else {
          this.$message.error('缺少优惠券ID')
          this.$router.push('/coupon/index')
        }
      }
    }
  },
  methods: {
    async fetchDetail() {
      this.loading = true
      try {
        const res = await getCouponDetail({ id: this.couponId })
        this.coupon = res.data
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .page-title { font-size: 15px; font-weight: 600; color: #303133; }
  .page-actions { display: flex; gap: 8px; }
}

.detail-form { max-width: 620px; padding-top: 8px; }
.val-text     { color: #303133; font-size: 13px; }
.val-text.bold { font-weight: 600; font-size: 14px; }
.val-price    { color: #f56c6c; font-weight: 600; font-size: 15px; }
.text-muted   { color: #c0c4cc; font-size: 13px; }
</style>
